module.exports = __webpack_public_path__ + "img/locationsvg.773eba5c.svg";